export const HUB_LOCATIONS = ["LAX1", "EWR1"];
